var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 75,
    viewBox: "0 0 81 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41531 74.1165H74.6143C79.383 74.1165 82.4532 69.0865 80.2975 64.8404L46.198 4.41504C43.8457 -0.287681 37.1179 -0.287681 34.7662 4.41504L0.666736 64.8404C-1.42365 69.0865 1.64661 74.1165 6.41531 74.1165ZM45.8721 60.0717C45.8721 63.2073 43.5857 65.6243 40.3195 65.6243C37.0532 65.6243 34.7669 63.2073 34.7669 60.0717V59.941C34.7669 56.8054 37.0532 54.3884 40.3195 54.3884C43.5857 54.3884 45.8721 56.8054 45.8721 59.941V60.0717ZM37.3139 19.2437H43.7164C45.4795 19.2437 46.5253 20.7462 46.3293 22.6406L43.5197 47.2027C43.3238 48.9665 42.1479 50.077 40.5148 50.077C38.8817 50.077 37.7058 48.9665 37.5099 47.2027L34.7002 22.6406C34.5049 20.7462 35.5508 19.2437 37.3139 19.2437Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6e0c2c454384f9b217fd680b2a567063.svg";
export { ForwardRef as ReactComponent };